export enum FORM_POLL_CHOICE_TYPE {
    NORMAL = 'NORMAL'
}